var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-visualizer"},[(_vm.loading)?_c('busy-overlay',{attrs:{"enabled":_vm.loading,"loading":_vm.loading,"message":'loading'}}):_vm._e(),_vm._v(" "+_vm._s(_vm.analysis)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }